import React from 'react';
import type { IconComponentProps } from '@/types/components';

export const GraphBar: React.FC<IconComponentProps> = ({ className }) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.571289 1.17861C0.571289 0.863014 0.827127 0.607178 1.14272 0.607178H3.99986C4.31545 0.607178 4.57129 0.863015 4.57129 1.17861V14.8572C4.57129 15.1727 4.31545 15.4286 3.99986 15.4286H1.14272C0.827127 15.4286 0.571289 15.1727 0.571289 14.8572V1.17861ZM11.4284 4.00003C11.4284 3.68445 11.6843 3.42861 11.9999 3.42861H14.857C15.1725 3.42861 15.4284 3.68445 15.4284 4.00003V14.8572C15.4284 15.1727 15.1725 15.4286 14.857 15.4286H11.9999C11.6843 15.4286 11.4284 15.1727 11.4284 14.8572V4.00003ZM6.57129 6.28575C6.2557 6.28575 5.99986 6.54159 5.99986 6.85718V14.8572C5.99986 15.1727 6.2557 15.4286 6.57129 15.4286H9.42843C9.74402 15.4286 9.99986 15.1727 9.99986 14.8572V6.85718C9.99986 6.54159 9.74402 6.28575 9.42843 6.28575H6.57129Z"
      fill="currentColor"
    />
  </svg>
);
